import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import { FormattedMessage } from 'react-intl';

import ConfirmButton from '../ConfirmButton';

const styles = theme => ({
  acceptInvitationWarning: {
    fontWeight:700,
    display:'block',
    marginBottom: 16
  },
  acceptInvitation: {
    display:'block'
  }
})

const AcceptDomainInvitationButton = ({
  classes,
  invitation,
  handleAccept,
  size="small",
  color="primary",
  variant="contained",
  ...props,
}) => (
  <ConfirmButton
    size={size}
    color={color}
    variant={variant}
    onClick={handleAccept}
    message={
      <div>
        <span className={classes.acceptInvitationWarning}>
          <FormattedMessage 
            id="invitation.confirmation.acceptInvitationWarning" 
            values={{
              ownerEmail: invitation 
                && invitation.owner 
                && invitation.owner.email
            }}  
          />
        </span>
        <span className={classes.acceptInvitation}>
          <FormattedMessage id="invitation.confirmation.acceptInvitation" />
        </span>
      </div>
    }
    yes={
      <FormattedMessage id='invitation.confirmation.yes' />
    }
    no={
      <FormattedMessage id='invitation.confirmation.no' />
    }
    title={
      <FormattedMessage id='invitation.confirmation.title' />
    }
    {...props}
  >
    <FormattedMessage id='invitation.button.acceptInvitation' />
  </ConfirmButton>
);

AcceptDomainInvitationButton.propTypes = {
  classes: PropTypes.object.isRequired,
  invitation: PropTypes.object.isRequired,
  handleAccept: PropTypes.func,
}

export default withStyles(styles)(
  AcceptDomainInvitationButton
);


// WEBPACK FOOTER //
// ./src/components/domains/AcceptDomainInvitationButton.js